import type { MittwaldAPIV2Client } from "@mittwald/api-client-NEXT";
import { assertStatus } from "@mittwald/api-client-NEXT";
import type { MySqlBehaviors } from "./types.js";
import { checkForValidationErrors } from "../../../base/index.js";

export const apiMySqlBehaviors = (
  client: MittwaldAPIV2Client,
): MySqlBehaviors => ({
  find: async (mysqlDatabaseId) => {
    const response = await client.database.getMysqlDatabase({
      mysqlDatabaseId,
    });
    if (response.status === 200) {
      return response.data;
    }
    assertStatus(response, 404);
  },

  list: async (projectId) => {
    const response = await client.database.listMysqlDatabases({
      projectId,
    });
    assertStatus(response, 200);
    return {
      items: response.data,
    };
  },

  create: async (projectId, data) => {
    const response = await client.database.createMysqlDatabase({
      projectId,
      data,
    });

    const validationErrors = checkForValidationErrors(response);
    if (validationErrors) {
      return validationErrors;
    }

    assertStatus(response, 201);
    return response.data;
  },

  listVersions: async () => {
    const response = await client.database.listMysqlVersions();
    assertStatus(response, 200);
    return response.data;
  },

  delete: async (mysqlDatabaseId) => {
    const response = await client.database.deleteMysqlDatabase({
      mysqlDatabaseId,
    });
    assertStatus(response, 204);
  },

  updateDescription: async (mysqlDatabaseId, description) => {
    const response = await client.database.updateMysqlDatabaseDescription({
      mysqlDatabaseId,
      data: { description },
    });
    assertStatus(response, 204);
  },
});
